import React, { createContext, useContext, useState } from 'react';
import { FormProvider as RHFFormProvider } from 'react-hook-form';
import { useFormController } from '../hooks';

const MethodsContext = createContext();

export const useFormMethods = () => useContext(MethodsContext);

export const FormControllerProvider = ({ options, children }) => {
  const formData = useFormController({
    ...options,
    mode: options?.mode ?? 'onChange',
  });

  const { formState, control, register, ..._methods } = formData;

  const [methods] = useState(() => _methods);

  return (
    <RHFFormProvider {...formData}>
      <MethodsContext.Provider value={methods}>
        {children}
      </MethodsContext.Provider>
    </RHFFormProvider>
  );
};
